module.exports = __webpack_public_path__ + "static/media/yotpo-circle@3x.929bb718.png";